import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { useMemo } from "react";

import { Icon } from "src/base-components/Icon";

const loadingTexts = [
  "Analyzing your request...",
  "Crafting a response...",
  "Thinking it through...",
  "Processing data...",
  "Generating insights...",
  "Preparing assistance...",
  "Computing solution...",
  "Decoding your query...",
  "Synthesizing answer...",
  "Formulating response...",
];

export const LoadingMessageItem = () => {
  const randomIndex = useMemo(
    () => Math.floor(Math.random() * loadingTexts.length),
    [],
  );

  return (
    <li className="flex flex-col gap-y-2">
      <p className="text-gray-500 font-inter-normal-12px">Copilot</p>
      <div className="flex">
        <Icon color="text-gray-500" icon={faSpinner} size="xs" spin />
        <span className="text-gray-800 font-inter-normal-13px">
          {loadingTexts[randomIndex]}
        </span>
      </div>
    </li>
  );
};
